import { gql } from "@apollo/client"
import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"

/** Archives a work package, making it read-only. */
export const archiveProject = api(async function archiveProject({ projectId }) {
    return mutate(
        gql`
            mutation ArchiveProject($projectId: String!) {
                archiveProject(projectId: $projectId) {
                    success
                    error
                }
            }
        `,
        { projectId },
        { returns: "archiveProject" }
    )
})
